import type { RouteRecordRaw, RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { useUser } from "@/shared/account";
import { CustomPermissions } from "@/core/enums";

// const Info = () => import("@/pages/company/info.vue");
const SapInfo = () => import("@/pages/company/innovadis/inno-info.vue");
const Members = () => import("@/pages/company/members.vue");

// Innovadis custom: route guards for company information permission
const companyInfoGuard = (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const { checkPermissions } = useUser();
  if (!checkPermissions(CustomPermissions.ShowViewCompanyInformation)) {
    next({ name: "Account" });
  } else {
    next();
  }
};

// Innovadis custom: route guards for user management permission
const companyMembersGuard = (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const { checkPermissions } = useUser();
  if (!checkPermissions(CustomPermissions.ShowUserManagement)) {
    next({ name: "Account" });
  } else {
    next();
  }
};

export const corporateRoutes: RouteRecordRaw[] = [
  { path: "info", name: "CompanyInfo", component: SapInfo, beforeEnter: companyInfoGuard },
  { path: "members", name: "CompanyMembers", component: Members, beforeEnter: companyMembersGuard },
];
